<template>
    <div class="box-wrap" :style="boxWrapStyleObj">
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div class="statis-title bg2" ref="statisTitle">
            <span>{{ ebookCountList.name }}</span>
        </div>
        <div class="content" :style="contentStyleObj"  >
            <div :id="`chart-${id}`"  style="width:100%;height:100%;position: absolute;"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ebookStatis",
    data() {
        return {
            boxWrapStyleObj: {
                height: ''
            },
            contentStyleObj: {
                height: ''
            }
        }
    },
    props: {
        id: Number,
        ebookCountList: Array,
        screenHeight: Number,
        titleHeight: Number
    },
    watch: {
        ebookCountList(value) {
            if (value) {
                this.initChart();
            }
        },
        'screenHeight': 'initBoxHeight',
        'titleHeight': 'initBoxHeight',
    },
    methods: {
        /**
         * 初始化box高度
         */
        initBoxHeight() {
            let winHeight = window.innerHeight;
            if (winHeight < 900) {
                winHeight = 938;
            }

            let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
            let contentHeight = boxWrapHeight - this.$refs.statisTitle.offsetHeight - 20;
            // this.boxWrapHeight=boxWrapHeight;
            this.boxWrapStyleObj.height = boxWrapHeight + 'px';
            this.contentStyleObj.height = contentHeight + 'px';
        },
        /**
         * 初始化教师课堂行为柱状图
         */
        initChart() {

            const option = {
                color: ['#FC6787', '#fae17c', '#bd4ae3'],
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    bottom: '5%',
                    right: '5%',
                    orient: 'vertical',  // 设置为竖直排列
                    itemWidth: 5,  // 设置宽度
                    itemHeight: 5, // 设置高度
                    icon: 'circle', // 设置图例图标的形状
                    textStyle: {
                        rich: {
                            a: { color: '#FC6787' },
                            b: { color: '#fae17c' },
                            c: { color: '#bd4ae3' }
                        }
                    },
                    formatter: function (name) {
                        switch (name) {
                            case '小学':
                                return '{a|' + name + '}';
                            case '初中':
                                return '{b|' + name + '}';
                            case '高中':
                                return '{c|' + name + '}';
                        }
                    }
                },
                series: [
                    {
                        name: '资源量',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        center: ['47%', '50%'],
                        avoidLabelOverlap: true,
                        label: {
                            show: true,
                            formatter(param) {
                                return param.name + ' (' + param.percent + '%)';
                            }
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: 40,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true
                        },
                        data: this.ebookCountList.data
                    }
                ]
            }; 
            let dataChart = this.$echarts.init(document.getElementById(`chart-${this.id}`));
            dataChart.setOption(option);
            window.addEventListener('resize', function () {
                dataChart.resize();
            });
        }
    },
    mounted() {
        
    }
}
</script>
<style lang="scss" scoped>
@import "../../../style/databoard";

.bg2 {
    background-image: url("../../../assets/images/databoard/title-bg2.png");
}
</style>
